import { API_HOST, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/registration`;

export const getRegisterSystemUserRequest = (systemUser) => [getEndpoint(), getHttpPostOptions(systemUser)];
